import "./carrer.css";
import curvedbg1 from "../../images/curved-bg1.svg";


const Carrer = () => {
  return (
    <>
      <div className="carrer">
        <img src={curvedbg1} className="curve1" alt="" />
        <img src={curvedbg1} className="curve2" alt="" />
        <img src={curvedbg1} className="curve3" alt="" />
        <h1>Careers</h1>
        <p>
          Iwosan Healthcare Systems  Limited is a privately held healthcare asset and
          investment company dedicated to financing and developing brownfield
          and greenfield multi-specialist healthcare facility
        </p>
      </div>
      <section className="news">
        <div className="news__post">
          <h2>Technical Career</h2>
          <p className="news__time">Romeo Stars on 24 March 2020</p>
          <blockquote className="news__blockquote">
            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Vitae
            ducimus, reiciendis suscipit tempore voluptas tenetur, vero
            obcaecati recusandae, nostrum natus hic exercitationem delectus
            voluptatum! Cum minima, sequi molestias perspiciatis reiciendis
            totam iure voluptate, nulla accusamus pariatur non? Vitae officia
            illum earum enim, mollitia necessitatibus illo nam! Eum labore
            excepturi fuga.
          </blockquote>
          <button className="news__button">Read More</button>
        </div>
        <div className="news__picture"></div>
      </section>
      <section className="news blue-background">
        <div className="news__post">
          <h2>Non-technical Career</h2>
          <p className="news__time" style={{ color: "hsla(138, 48%, 59%, 1)" }} >Romeo Stars on 24 March 2020</p>
          <blockquote className="news__blockquote">
            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Vitae
            ducimus, reiciendis suscipit tempore voluptas tenetur, vero
            obcaecati recusandae, nostrum natus hic exercitationem delectus
            voluptatum! Cum minima, sequi molestias perspiciatis reiciendis
            totam iure voluptate, nulla accusamus pariatur non? Vitae officia
            illum earum enim, mollitia necessitatibus illo nam! Eum labore
            excepturi fuga.
          </blockquote>
          <button className="news__button">Read More</button>
        </div>
        <div className="news__picture"></div>
      </section>
    </>
  );
};
export default Carrer;
